import moment from "moment";

export interface DocumentV1FormState {
  documentId: number;
  addresseeCompany: server.dto.CompanySmall;
  artistRider: server.dto.ArtistRider;
  subject: string;
  contact: server.dto.ContactSmallV2;
  currency: server.dto.Currencies;
  exchangeRate: number;
  lifeCycle: server.dto.DocumentLifeCycle;
  completed: moment.Moment;
  lifeCycleReason: string;
  owner: server.dto.UserSmall;
  sendDate: moment.Moment;
  dueInDays: number;
  status: server.dto.StatusSmall;
  bankAccount: server.dto.BankAccountSmall;
  costCenter: server.dto.CostCenter;
}

export const documentFormStateToUpdateDocumentInstruction = (state: DocumentV1FormState): server.dto.UpdateDocumentV1Instruction => ({
  documentId: state.documentId,
  addresseeCompanyId: state.addresseeCompany.companyId,
  artistRiderId: state.artistRider?.artistRiderId,
  lifeCycleDateComplete: state.completed ? state.completed.toDate() : undefined,
  concerning: state.subject,
  contactId: state.contact?.contactId,
  currency: state.currency,
  dueInDays: state.dueInDays,
  exchangeRate: state.exchangeRate,
  lifeCycle: state.lifeCycle.value,
  lifeCycleReason: state.lifeCycleReason,
  ownerUserId: state.owner.userId,
  sendDate: state.sendDate.toDate(),
  statusId: state.status?.statusId,
});

export const documentFormStateToUpdateInvoiceInstruction = (state: DocumentV1FormState): server.dto.UpdateInvoiceV1Instruction => ({
  invoiceId: state.documentId,
  addresseeCompanyId: state.addresseeCompany.companyId,
  bankAccountId: state.bankAccount?.bankAccountId,
  concerning: state.subject,
  contactId: state.contact?.contactId,
  costCenterId: state.costCenter?.costCenterId,
  currency: state.currency,
  dueInDays: state.dueInDays,
  exchangeRate: state.exchangeRate,
  invoiceDate: state.sendDate.toDate(),
  isDraft: state.lifeCycle.value === "draft",
  ownerUserId: state.owner.userId,
  statusId: state.status.statusId,
});

export const mapDocumentToFormState = (document: server.dto.DocumentV1): DocumentV1FormState => ({
  documentId: document.documentId,
  addresseeCompany: document.addressee,
  artistRider: document.artistRider,
  subject: document.subject,
  contact: document.contact,
  currency: document.currency,
  exchangeRate: document.exchangeRate,
  lifeCycle: document.lifeCycleInfo.lifeCycle,
  lifeCycleReason: document.lifeCycleInfo.reason,
  owner: document.owner,
  sendDate: moment.utc(document.send.value),
  dueInDays: moment.utc(document.due.value).diff(moment.utc(document.send.value), "days"),
  status: document.status,
  completed: document.lifeCycleInfo.completed ? moment.utc(document.lifeCycleInfo.completed) : null,
  bankAccount: null,
  costCenter: document.costCenter,
});

export const mapInvoiceToFormState = (invoice: server.dto.InvoiceV1): DocumentV1FormState => ({
  documentId: invoice.invoiceId,
  addresseeCompany: invoice.company,
  artistRider: null,
  subject: invoice.concerning,
  contact: invoice.contact,
  currency: invoice.currency,
  exchangeRate: invoice.exchangeRate,
  lifeCycle: {
    text: "ad",
    value: invoice.lifeCycle
  },
  completed: null,
  lifeCycleReason: "",
  owner: invoice.owner,
  sendDate: moment.utc(invoice.invoiceDate),
  dueInDays: invoice.dueInDays,
  status: invoice.status,
  bankAccount: invoice.bankAccount,
  costCenter: invoice.costCenter,
});
